import { MouseEvent, useCallback } from 'react';

import { NotificationListItem } from 'components/NotificationList/Item/NotificationListItem';
import { LocalNotificationStatus } from 'types/LocalNotification/LocalNotificationStatus';
import { MappedLocalNotification } from 'types/LocalNotification/MappedLocalNotification';
import { updateLocalNotification } from 'zustand-stores/localNotificationsStore';

type Props = {
  notification: MappedLocalNotification;
  dismissible: boolean;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
};

export function LocalNotificationListItem({
  notification,
  dismissible,
  onClick,
}: Props) {
  const handleClick = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      updateLocalNotification(notification.type, { read: true });
      onClick?.(event);
    },
    [notification, onClick],
  );

  const handleDismiss = useCallback(
    () =>
      updateLocalNotification(notification.type, {
        status: LocalNotificationStatus.DISMISSED,
        read: true,
      }),
    [notification],
  );

  return (
    <NotificationListItem
      notification={notification}
      onClick={handleClick}
      onDismiss={dismissible ? handleDismiss : undefined}
      qaId="notification"
    />
  );
}
